import "./markup-menu";
import $ from 'jquery'
import sliders from './components/sliders'
global.$ = global.jQuery = $
require("./components/open-close");
document.addEventListener("DOMContentLoaded", () => {
  if ($('.countdown').length) {
    const timers = document.querySelectorAll(".countdown");

    function updateTimer(el) {
      const now = new Date();
      const endDateStr = el.getAttribute("data-end");
      if (!endDateStr) return;

      // Конечная дата — 00:00 указанного дня
      const [year, month, day] = endDateStr.split("-").map(Number);
      const endDate = new Date(year, month - 1, day, 0, 0, 0, 0);

      let diff = endDate - now;
      if (diff <= 0) diff = 0;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      el.querySelector(".days").textContent = String(days).padStart(2, "0");
      el.querySelector(".hours").textContent = String(hours).padStart(2, "0");
      el.querySelector(".minutes").textContent = String(minutes).padStart(2, "0");
      el.querySelector(".seconds").textContent = String(seconds).padStart(2, "0");
    }

    function startCountdowns() {
      timers.forEach(el => updateTimer(el));
      setInterval(() => timers.forEach(el => updateTimer(el)), 1000);
    }

    startCountdowns();
  };
  class TableOfContent {
    constructor() {
      this.tocContainer = document.querySelector(".content-nav");
      this.tocParentContainer = this.tocContainer.parentElement;
      this.tocElementsContainter = this.tocContainer.querySelector(
        ".content-nav__wrapper ul"
      );
      this.anchors = this.tocContainer.querySelectorAll(".content-nav__link");
      this.arrowLeft = this.tocContainer.querySelector(
        ".content-nav__prev"
      );
      this.arrowRight = this.tocContainer.querySelector(
        ".content-nav__next"
      );
      this.defineMobileDependentProperties();
    }

    defineMobileDependentProperties() {
      if (this.isMobile()) {
        this.headerOffset = 140;
        this.intersectionTopOffset = this.headerOffset + 60;
        this.sideOffset = 0;
      } else {
        this.headerOffset = 200;
        this.intersectionTopOffset = this.headerOffset + 300;
        this.sideOffset = 96;
      }
    }

    isMobile() {
      return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    displayArrowLeft() {
      this.arrowLeft.style.display =
        this.tocElementsContainter.scrollLeft - this.sideOffset <= 0
          ? "none"
          : "block";
    }

    displayArrowRight() {
      this.arrowRight.style.display =
        this.tocElementsContainter.scrollLeft +
          this.tocElementsContainter.offsetWidth +
          this.sideOffset >=
        this.tocElementsContainter.scrollWidth
          ? "none"
          : "block";
    }

    displayNavigation() {
      this.displayArrowLeft();
      this.displayArrowRight();
    }

    scrollLeft(amount = 200) {
      this.tocElementsContainter.scrollBy({
        left: -amount,
        behavior: "smooth",
      });
      setTimeout(() => this.displayNavigation(), 200);
    }

    scrollRight(amount = 200) {
      this.tocElementsContainter.scrollBy({
        left: amount,
        behavior: "smooth",
      });
      setTimeout(() => this.displayNavigation(), 200);
    }

    addAnchorClickEvent(anchor) {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        const target = document.getElementById(anchor.getAttribute("href").slice(1));
        if (!target) return;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - this.headerOffset,
          behavior: "smooth",
        });
      });
    }

    addArrowClickEvents() {
      this.arrowLeft.addEventListener("click", () => this.scrollLeft(100));
      this.arrowRight.addEventListener("click", () => this.scrollRight(100));
    }



observeAnchors() {
  let activeTimeout;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("id");
        const current = document.querySelector(
          `.content-nav__link[href="#${id}"]`
        );
        if (!current) return;

        if (entry.isIntersecting) {
          clearTimeout(activeTimeout);
          this.anchors.forEach((a) => a.parentElement.classList.remove("active"));
          current.parentElement.classList.add("active");
        } else {
          activeTimeout = setTimeout(() => {
            current.parentElement.classList.remove("active");
          }, 200); // задержка 200 мс
        }
      });
    },
    { threshold: 0.3 }
  );

  document.querySelectorAll("[id]").forEach((el) => observer.observe(el));
}



    makeTocContainerSticky() {
      const checkSticky = () => {
        const topOffset =
          this.tocParentContainer.getBoundingClientRect().top + window.scrollY - 120;
        const height = this.tocContainer.offsetHeight;

        if (window.scrollY >= topOffset) {
          this.tocContainer.classList.add("sticky-toc");
          this.tocParentContainer.style.minHeight = height + "px";
        } else {
          this.tocContainer.classList.remove("sticky-toc");
          this.tocParentContainer.style.removeProperty("minHeight");
        }
      };
      window.addEventListener("scroll", this.throttle(checkSticky, 200));
    }

    throttle(func, limit) {
      let lastRun;
      let timeout;
      return function () {
        const now = Date.now();
        if (!lastRun) {
          func();
          lastRun = now;
        } else {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            if (now - lastRun >= limit) {
              func();
              lastRun = now;
            }
          }, limit - (now - lastRun));
        }
      };
    }

    init() {
      this.anchors.forEach((a) => this.addAnchorClickEvent(a));
      this.addArrowClickEvents();
      this.displayNavigation();
      setTimeout(() => this.observeAnchors(), 500);
      this.makeTocContainerSticky(); // <-- оставляем sticky
    }
  }

  if (document.querySelector(".content-nav")) {
    const toc = new TableOfContent();
    toc.init();
  }

  sliders();
  $(document).on('click', (e) => {
    if (!$(e.target).closest('.lang__list, .lang__active').length) {
      $('.lang__list').removeClass('show');
    }
    e.stopPropagation();
  });
  $(".lang__active").click(function() {
    $(this).toggleClass('active');
    $(this).siblings().toggleClass('show');
  });
  $(".question").click(function() {
    $(this).parents().toggleClass('active');
  });
  $(".mobile-opener").click(function() {
    $(this).toggleClass('active');
    $('.header__box').toggleClass('show');
  });
  $(".white-theme").click(function() {
    $('.popup').css('display', 'none');
  });
  $(".black-theme-btn").click(function() {
    $('.popup').css('display', 'none');
    $('body').addClass('black-theme');
  });
});



// WEBPACK FOOTER //
// app/scripts/index.js